import { SLF_SEL, DEFAULT_SETTINGS, MAIN_LAYOUT_SELECTORS } from '../constants';

function getTextColorStyles(designSettings) {
    const font = `"${designSettings.typography.fontFamily}"`;
    const { primaryTextColor } = designSettings.typography;
    const { secondaryTextColor } = designSettings.typography;
    const aColor = designSettings.typography.hyperlinkColor;
    const aHovColor = designSettings.typography.hyperlinkHoverColor;
    return {
        '': {
            fontFamily: font,
            color: primaryTextColor,
        },
        input: {
            color: primaryTextColor,
            fontFamily: font,
        },
        button: {
            color: primaryTextColor,
            fontFamily: font,
        },
        a: { color: aColor },
        [`
            .slf-text-href,
            .slf-text-href-hov,
            .btn.slf-text-href,
            .btn.slf-text-href-hov,
            .link
            `]: { color: aColor },
        [`
            .slf-text-href:hover,
            a:hover,
            .link:hover,
            .slf-text-href-hov:hover
            `]: { color: aHovColor },
        'input::placeholder': { color: secondaryTextColor },
        'input:disabled': { color: secondaryTextColor },
        textarea: {
            fontFamily: 'inherit',
            color: primaryTextColor,
        },
        '.slf-text-primary': { color: primaryTextColor },
        '.slf-text-primary:hover': { color: primaryTextColor },
        '.slf-text-secondary': { color: secondaryTextColor },
        '.slf-text-secondary-hov': {
            color: secondaryTextColor,
            transition: 'color 0.2s ease',
        },
        '.slf-text-secondary-hov:hover': { color: primaryTextColor },
    };
}

export default function (designSettings) {
    const { secondaryTextColor } = designSettings.typography;
    const baseColorsSettings = { ...DEFAULT_SETTINGS,
        typography: {
            ...DEFAULT_SETTINGS.typography,
            fontFamily: designSettings.typography.fontFamily,
        },
    };
    return {
        // Popups should have default text colors
        ...getTextColorStyles(baseColorsSettings),
        [MAIN_LAYOUT_SELECTORS]: {
            ...getTextColorStyles(designSettings),
            [SLF_SEL.DEFAULT]: {
                ...getTextColorStyles(baseColorsSettings),
            },
            '.custom-checkbox__input': {
                '&:disabled': {
                    '+ .custom-checkbox__icon': {
                        borderColor: secondaryTextColor,
                    },
                    '+ .custom-checkbox__icon + .custom-checkbox__text': {
                        color: secondaryTextColor,
                    },
                },
            },
        },
    };
}
